var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIconSignModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1145_6652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9993 4.66602C15.1193 4.66602 4.66602 15.1193 4.66602 27.9993C4.66602 40.8793 15.1193 51.3327 27.9993 51.3327C40.8793 51.3327 51.3327 40.8793 51.3327 27.9993C51.3327 15.1193 40.8793 4.66602 27.9993 4.66602ZM27.9993 46.666C17.7093 46.666 9.33268 38.2893 9.33268 27.9993C9.33268 17.7093 17.7093 9.33268 27.9993 9.33268C38.2893 9.33268 46.666 17.7093 46.666 27.9993C46.666 38.2893 38.2893 46.666 27.9993 46.666ZM38.7093 17.686L23.3327 33.0627L17.2893 27.0427L13.9993 30.3327L23.3327 39.666L41.9993 20.9993L38.7093 17.686Z",
    fill: "#30A867"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1145_6652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIconSignModal);
export default __webpack_public_path__ + "static/media/successIconSignModal.52bf4c6c290a8e645e67a03f5d293083.svg";
export { ForwardRef as ReactComponent };